import { mapState, mapGetters, mapActions } from 'vuex'

// computed
export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    modalPassword : (state) => state.modalPassword,
  }),
  ...mapGetters('auth', ['loggedIn', 'getUser']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarTheme: (state) => state.leftSidebarTheme,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
  }),
}

export const pageComputed = {
  ...mapState('page', {
    pageValue : (state) => state.pageValue,
  }),
  ...mapGetters('page', ['getPageValue']),
}



// methods
export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'changePassword',
  'showModalPassword'
])

export const layoutMethods = mapActions('layout', [
  'changeLayoutType',
  'changeLeftSidebarTheme',
  'changeLeftSidebarType',
  'changeLayoutWidth',
])

export const crudMethods = mapActions('crud', [
  'insertData',
  'updateData',
  'updateDataPost',
  'getData',
  'listData',
  'deleteData',
  'cariData',
  'downloadData'
])

export const pageMethods = mapActions('page', [
  'setPageValue',
])
